export function breadcrumbsFactory($resource, MyConstant) {
    "ngInject"
    return $resource('', {}, {
        getByType: {
            url: `${MyConstant.ApiUrl}Settings/GetBreadCrumbByTypeID?typeID=:typeID`,
            params: { typeID: '@productTypeID' },
            isArray: true,
            cache: true
        },
        getByCat: {
            url: `${MyConstant.ApiUrl}Settings/GetBreadCrumbByCatID?catID=:catID`,
            params: { catID: '@categoryID' },
            isArray: true,
            cache: true
        },
        getByProduct: {
            url: `${MyConstant.ApiUrl}Settings/GetBreadCrumbByProductID?productId=:productId`,
            params: { productId: '@productId' },
            isArray: true,
            cache: true
        }
    })
}


// WEBPACK FOOTER //
// ./src/factories/breadcrumbs/breadcrumbs.ts